<template>
  <page>
    <form data-vv-scope="reportForm">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Date Range
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <cal-picker v-model="reportForm.fromDate" :label="labels.fromDate" v-validate="'required'" :data-vv-as="labels.fromDate" data-vv-name="reportForm.fromDate" :error-messages="errors.collect('reportForm.fromDate')"></cal-picker>
            </v-flex>
            <v-flex xs6>
              <cal-picker v-model="reportForm.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="reportForm.toDate" :error-messages="errors.collect('reportForm.toDate')"></cal-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Selection Criteria
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xsl2>
                       <v-text-field v-model="reportForm.polNo" :label="labels.polNo" :error-messages="errors.collect('reportForm.polNo')" data-vv-name="reportForm.polNo" :data-vv-as="labels.polNo" @blur="doExpandSubFilter">
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showPolicyHelpList = true">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete :items="rencnt" v-model="reportForm.renCnt" :label="labels.renCnt" item-text="label" item-value="value" data-vv-name="reportForm.renCnt" :data-vv-as="labels.renCnt" :error-messages="errors.collect('reportForm.renCnt')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete :items="endtcnt" v-model="reportForm.endtCnt" :label="labels.endtCnt" item-text="label" item-value="value" data-vv-name="reportForm.endtCnt" :data-vv-as="labels.endtCnt" :error-messages="errors.collect('reportForm.endtCnt')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
     <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xsl2>
                       <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('reportForm.branch')" data-vv-name="reportForm.branch" :data-vv-as="labels.branch" v-validate="'required'">
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showBranchHelpList = true">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                    </v-flex>
                    <v-flex xsl2>
                       <v-text-field v-model="reportForm.department" :label="labels.department" :error-messages="errors.collect('reportForm.department')" data-vv-name="reportForm.department" :data-vv-as="labels.department" v-validate="'required'">
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showDepartmentHelpList = true">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete :items="directRiInwards" v-model="reportForm.directRiInward" :label="labels.directRiInward" item-text="label" item-value="value" data-vv-name="reportForm.directRiInward" :data-vv-as="labels.directRiInward" :error-messages="errors.collect('reportForm.directRiInward')"></v-autocomplete>
                    </v-flex>
                    <v-flex xsl2>
                       <v-text-field v-model="reportForm.polType" :label="labels.polType" :error-messages="errors.collect('reportForm.polType')" data-vv-name="reportForm.polType" :data-vv-as="labels.polType" v-validate="'required'">
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showPolicyTypeHelpList = true">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                    </v-flex>
                    <v-flex xsl2>
                      <v-checkbox color="primary" :label="labels.includeRelPolAE" v-model="reportForm.includeRelPolAE"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex lg6 xs12>
      <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
      <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
            Export To
        </v-btn>
         <v-btn-toggle dense mandatory v-model="reportForm.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{format.label}}</span>
            <v-icon :color="format.color">{{format.icon}}</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-dialog v-model="showErrorDialog" width="800px">
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="headline">System Information</div>
                <span class="grey--text">An error occurred.</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-if="messages.length > 0" class="pb-3">
                <v-subheader>Error Details:</v-subheader>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                    {{error.message}}
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </form>

    <v-dialog v-model="showPolicyHelpList" width="1280px" persistent>
      <policy-help-list @close="showPolicyHelpList = false" :apiURI="this.menu.policyList" @assignPolicyInfo="assignPolicyInfo"></policy-help-list>
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="brn" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="showDepartmentHelpList" width="900px" persistent>
      <multi-dept-help-list :dept="dept" @close="doClose" @doAssign="doAssignDept($event)"></multi-dept-help-list>
    </v-dialog>

    <v-dialog v-model="showPolicyTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="pt" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import PolicyHelpList from './PolicyHelpList.vue'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import { expandURI } from '@/utils/ajax'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: 'Transaction Date To*',
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        endtCnt: 'Endorsement Count',
        branch: 'Branch',
        department: 'Department',
        directRiInward: 'Direct /RI Inward',
        polType: 'Policy Type',
        includeRelPolAE: 'Include Released Policy',
        format: '',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        fromDate: '',
        toDate: new Date(),
        polNo: null,
        renCnt: null,
        endtCnt: null,
        branch: 'All',
        department: 'All',
        directRiInward: null,
        polType: 'All',
        includeRelPolAE: false,
        printRptRunTime: true
      },
      showPolicyHelpList: false,
      showBranchHelpList: false,
      showDepartmentHelpList: false,
      showPolicyTypeHelpList: false,
      showErrorDialog: false,
      supportedFormat: [],
      rencnt: [
        { label: '0', value: '0' }
      ],
      endtcnt: [
        { label: '0', value: '0' }
      ],
      subPanel: [false],
      menu: {},
      submitting: false,
      apiURI: null,
      polRenCnt: null,
      polEndtCnt: null,
      brn: '',
      dept: '',
      pt: '',
      directRiInwards: [
        { label: 'Both', value: 'B' },
        { label: 'Direct', value: 'D' },
        { label: 'RI Inwards', value: 'I' }
      ],
      panel: [0],
      panel1: [0],
      panel2: []
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    toDateValidation() {
      if (this.reportForm.fromDate !== '' && this.reportForm.fromDate !== null) {
        return 'required|valToDate:' + this.reportForm.fromDate
      } else {
        return ''
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.initUWReports()])
      await Promise.all([this.initPolChk()])
    },
    async initUWReports() {
      this.reportForm.renCnt = '0'
      this.reportForm.endtCnt = '0'
      this.reportForm.directRiInward = 'D'
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
    },
    async initPolChk() {
      const apiURI = this.rptMenu.initPolChkList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
          }
        } catch (err) {
          throw err
        }
      }
    },
    doExpandSubFilter() {
      if (this.reportForm.polNo === null || this.reportForm.polNo === '') {
        this.subPanel = [true]
      }
    },
    async getDataList(listName, paramString) {
      const apiUrl = this.menu.dataList
      if (apiUrl) {
        const params = {
          listName: listName,
          paramString: paramString
        }
        const result = await this.$http.get(expandURI(apiUrl, params))
        if (result.data.dataList) {
          this.$set(this, listName, result.data.dataList)
        }
        if (listName === 'rencnt') {
          this.reportForm.renCnt = this.polRenCnt
        } else if (listName === 'endtcnt') {
          this.reportForm.endtCnt = this.polEndtCnt
        }
      }
    },
    assignPolicyInfo(data) {
      this.reportForm.polNo = data.polNo
      this.reportForm.renCnt = data.renCnt
      this.reportForm.endtCnt = data.endtCnt
      this.polRenCnt = data.renCnt
      this.polEndtCnt = data.endtCnt
      this.showPolicyHelpList = false
    },
    doAssignBranch(obj) {
      this.doAssign('branch', obj)
    },
    doAssignDept(obj) {
      this.doAssign('department', obj)
    },
    doAssignPolType(obj) {
      this.doAssign('polType', obj)
    },
    doAssign(from, Obj) {
      switch (from) {
        case 'branch':
          this.reportForm.branch = Obj.finalSelectedItems.toString()
          break
        case 'department':
          this.reportForm.department = Obj.finalSelectedItems.toString()
          break
        case 'polType':
          this.reportForm.polType = Obj.finalSelectedItems.toString()
          break
        default:
          this.$snotify.error('No Assignment Returned!')
      }
    },
    doClose() {
      this.showBranchHelpList = false
      this.showDepartmentHelpList = false
      this.showPolicyTypeHelpList = false
    },
    doExport() {
      this.$validator.validateAll('reportForm').then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  async created() {
    await Promise.all([this.doInit()])
    this.$validator.extend('valToDate', {
      getMessage(field, args) {
        return 'To Date must be equal or greater than From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var toDate = args[0]
        if (toDate) {
          return !(isAfter(removeTime(toDate), removeTime(value)))
        }
      }
    })
  },
  watch: {
    'reportForm.polNo': function () {
      if (this.reportForm.polNo !== '') {
        this.getDataList('rencnt', this.reportForm.polNo)
        this.getDataList('endtcnt', this.reportForm.polNo)
      } else {
        this.reportForm.renCnt = '0'
        this.reportForm.endtCnt = '0'
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    PolicyHelpList,
    MultiDeptHelpList,
    MultiPolTypeHelpList,
    MultiBranchHelpList
  }
}

</script>
